import {useMemo} from 'react'

import {DAY_PERIODS, getMeasurementTypeNameForDayPeriod} from '../constants/measurementTypes'
import {DayPeriod} from '../types'

import {useGlobalMeasurementTypesQuery} from '@settings/modules/measurements/hooks/queries/useGlobalMeasurementTypesQuery'
import {GlobalMeasurementType} from '@settings/modules/measurements/types/GlobalMeasurementType'

export function useStrengthMeasurementUnit(dayPeriod: DayPeriod | null): string | undefined {
  const {data: globalMeasurementTypes} = useGlobalMeasurementTypesQuery()

  const unit = useMemo(() => {
    if (!globalMeasurementTypes || !dayPeriod) {
      return undefined
    }

    const measurementTypeName = getMeasurementTypeNameForDayPeriod(dayPeriod)
    const measurementType = globalMeasurementTypes.find(
      (type: GlobalMeasurementType) => type.name === measurementTypeName
    )

    return measurementType?.unit
  }, [globalMeasurementTypes, dayPeriod])

  return unit
}

export function useAllStrengthMeasurementUnits(): Record<DayPeriod, string | undefined> {
  const {data: globalMeasurementTypes} = useGlobalMeasurementTypesQuery()

  const units = useMemo(() => {
    if (!globalMeasurementTypes) {
      return {
        1: undefined,
        2: undefined,
        3: undefined,
        7: undefined,
        28: undefined
      }
    }

    const result: Record<DayPeriod, string | undefined> = {} as Record<
      DayPeriod,
      string | undefined
    >

    DAY_PERIODS.forEach((dayPeriod) => {
      const measurementTypeName = getMeasurementTypeNameForDayPeriod(dayPeriod)
      const measurementType = globalMeasurementTypes.find(
        (type: GlobalMeasurementType) => type.name === measurementTypeName
      )
      result[dayPeriod] = measurementType?.unit
    })

    return result
  }, [globalMeasurementTypes])

  return units
}

export function formatLabelWithUnit(label: string, unit?: string): string {
  return unit ? `${label} (${unit})` : label
}
